import React from "react";
import withSvgIcon from "~/hocs/with-svg-icon";

export const AddIcon = withSvgIcon(
    <g>
        <path d="M261 109.5h-22V239H109.5v22H239v129.5h22V261h129.5v-22H261z" />
        <path d="M250 0C111.9 0 0 111.9 0 250s111.9 250 250 250 250-111.9 250-250S388.1 0 250 0zm156.3 406.3c-20.3 20.3-43.9 36.2-70.3 47.4-27.2 11.5-56.2 17.4-86 17.4s-58.8-5.8-86-17.4c-26.3-11.1-50-27.1-70.3-47.4-20.3-20.3-36.2-44-47.3-70.3C34.8 308.8 29 279.8 29 250s5.8-58.8 17.4-86c11.1-26.3 27.1-50 47.4-70.3C114 73.4 137.7 57.5 164 46.4 191.2 34.8 220.2 29 250 29s58.8 5.8 86 17.4c26.3 11.1 50 27.1 70.3 47.4 20.3 20.3 36.2 43.9 47.4 70.3 11.5 27.2 17.4 56.2 17.4 86s-5.8 58.8-17.4 86c-11.2 26.2-27.1 49.9-47.4 70.2z" />
    </g>
);
